export default class RepositoryError extends Error {
    constructor(repository, message) {
        super(message);
        this.repository = repository;
    }
}